import { Checkbox } from '@/shadcn/checkbox';
import { Label } from '@/shadcn/label';
import { cn } from '@/shadcn/lib/utils';

import { isLockedWidget } from '@/components/forms/utils/links';
import { useDynamicProps } from '@/hooks/useDynamicProps';
import { usePropsSynchronization } from '@/hooks/usePropsSynchronization';
import { TestId } from '@/types/testId';
import type { WidgetWriterProps } from '../widget.type';

export const CheckboxWidget = (rjsfProps: WidgetWriterProps) => {
  const props = useDynamicProps(rjsfProps);
  usePropsSynchronization(props, rjsfProps);

  const isDisabled =
    props.disabled ||
    props.readonly ||
    isLockedWidget(props.id, props.formContext?.links);
  return (
    <div
      className="flex items-start"
      key={props.id}
      title={isDisabled ? 'This checkbox is disabled' : undefined}
    >
      <Checkbox
        aria-label={props.label}
        checked={typeof props.value === 'undefined' ? false : props.value}
        data-cy={`checkbox-${props.name}`}
        data-testid={TestId.FormWriter.Checkbox.Checkbox}
        disabled={isDisabled}
        id={props.id}
        onCheckedChange={checked => props.onChange(checked)}
      />
      <Label
        className={cn(
          'cursor-pointer pt-[3px] pl-2 font-medium text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
          props.required &&
            'after:ml-1 after:text-destructive after:content-["*"]'
        )}
        data-testid={TestId.FormWriter.Checkbox.CheckboxLabel}
        htmlFor={props.id}
      >
        {props.label}
      </Label>
    </div>
  );
};
